import * as React from "react";
import { BaseComponent } from "../../../../../../react-core/Html/BaseComponent";
import { DashboardFilterStore } from "../../Store/Variable";
import { DashboardAction } from "../../Action/DashboardAction";
import { DashboardTab } from "../../Resource/Content";
import { ClientDashboardFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/DashboardFilter/ClientDashboardFiltersModel";
import { DashboardSummaryTiles } from "../Common/DashboardSummaryTiles";

interface IWorkflowFilterSummaryTilesProps {}

interface IWorkflowFilterSummaryTilesState {
    data?: ClientDashboardFiltersModel[];
    pressedId: number;
}

export class WorkflowFilterSummaryTiles extends BaseComponent<
    IWorkflowFilterSummaryTilesProps,
    IWorkflowFilterSummaryTilesState
> {
    constructor(props: IWorkflowFilterSummaryTilesProps) {
        super(props);
        this.state = {
            data: null,
            pressedId: null,
        };
        this.subscribeToStore(DashboardFilterStore, () => this.onStoreChange());
    }

    componentDidMount() {
        DashboardAction.getFilterList();
    }

    private onStoreChange() {
        this.setState({ pressedId: DashboardFilterStore.getPressedId(), data: DashboardFilterStore.getData() });
    }

    private onDelete = (filterId) => {
        const filter = this.state.data.find((ele) => ele.FilterId == filterId);
        DashboardAction.deleteDashboardFilter(filter);
    };

    public onSave(data: ClientDashboardFiltersModel): boolean {
        DashboardAction.putDashboardFilter(data);
        return;
    }

    private onReorder(newOrder: ClientDashboardFiltersModel[]) {
        const _newOrder = newOrder.map((ele, i) => {
            return { ...ele, FilterOrder: i + 1 };
        });
        return DashboardAction.orderDashboardFilter(_newOrder);
    }

    public onAdd(data: ClientDashboardFiltersModel): boolean {
        if (this.state.data?.length >= 15) {return;}

        DashboardAction.postDashboardFilter(data);
        return;
    }

    public render(): JSX.Element {
        return (
            <DashboardSummaryTiles
                data={this.state.data}
                onAdd={(v) => this.onAdd(v as ClientDashboardFiltersModel)}
                onSave={(v) => this.onSave(v as ClientDashboardFiltersModel)}
                onDelete={(id) => this.onDelete(id)}
                onReOrder={(newList) => this.onReorder(newList as ClientDashboardFiltersModel[])}
                currentTabIndex={DashboardTab.Workflow}
                pressedId={this.state.pressedId}
            />
        );
    }
}
